export const storeName = 'personaclick';

export default {
    INITIALIZE: `${storeName}.INITIALIZE`,
    SET_SETTINGS: `${storeName}.SET_SETTINGS`,
    CONSENTS_UPDATED: `${storeName}.CONSENTS_UPDATED`,
    SET_INITIALIZED: `${storeName}.SET_INITIALIZED`,
    SET_SEGMENT_ID: `${storeName}.SET_SEGMENT_ID`,
    ORDER_CONFIRMATION: `${storeName}.ORDER_CONFIRMATION`,
    HAS_DONE_REGISTRATION: `${storeName}.HAS_DONE_REGISTRATION`,
};
